<style scoped>
	.newsBox{ padding: 0 8px; margin-bottom: 12px;}
	.newRight{ width: 7rem;height: 5rem; background-size: cover;background-repeat: no-repeat;}
	.new{ display: flex;flex-direction: row;margin-top: 8px;border-bottom: 10px solid #fafafa;padding: 8px;}
	.newLeft{ flex: 1;padding-right: 8px;}
	.newLeft{ display: flex;flex-direction: column; }
	.newsTit{ flex: 1;font-size: 0.85rem; }
	.ctime{ font-size: 0.7rem; }
	.nodata{ min-height: calc(100vh); }
	.nodata img{ width: 100%; }
</style>
<template>
	<div class="template">
		<div class="newsBox">
			<div class="new" v-for="da in dataArr" @click="seeInfo(da)">
				<div class="newLeft">
					<div class="newsTit">{{da.title}}</div>
					<div class="ctime">{{da.create_time}}</div>
				</div>
				<div class="newRight" :style="{backgroundImage:'url('+imageUrl+da.pic+')',backgroundSize:classId===27?'contain':'cover'}"></div>
			</div>
			
			<div class="nodata" v-if="dataArr.length<1">
				<img src="../../../../public/img/74ebae016998d5fae28c89076ff97744.png"/>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				imageUrl:'http://www.1522znsj.com',
				pageNum: 1,
				pageTotal: 0,
				classId: 0,
				dataArr: [],
			}
		},
		created: function() {
			let _this = this;
			_this.classId = _this.$route.query.class_id;
			_this.getArr_api(_this.classId);
		},
		mounted: function() {
			let _this = this;
		},
		methods: {
			/*获取列表
			 创建于2019-11-25  作者：郑凯*/
			getArr_api(id) {
				let _this = this;
				let paramsObj = {
					"pageNumber": _this.pageNum,
					"limit5": 1000,
					"class_id": id
				};
				_this.$axios({
					method: 'get',
					url: '/api/getContentListByClassId',
					headers: {},
					params: paramsObj
				}).then((response) => {
					let resObj = response.data;
					//console.log(JSON.stringify(resObj)) //请求成功返回的数据
					if(resObj.status == '00') {
						_this.dataArr = resObj.data.data;
						_this.pageNum = resObj.data.pageNumber;
						_this.pageTotal = resObj.data.total;
					} else if(resObj.status == 1001) {

					}
				}).catch((error) => {
					_this.loading = true;
					return false;
				});
			},
			
			/**  * -----查看详情
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			seeInfo(obj, type) {
				let _this = this;
				if(type) {
					obj.type = type;
				}
				_this.$router.push({
					path: '/mnewInfo',
					query: {
						content_id: obj.content_id,
						type: obj.type
					}
				})
			},
		}
	}
</script>